/*
 * @Author: Terry
 * @Date: 2022-03-15 11:14:51
 * @LastEditors: Terry
 * @LastEditTime: 2022-03-26 16:45:43
 * @FilePath: /shenghuorongmei_vue/Users/www/code_obj/toutiao_01/src/api/channel.js
 * @Description: 分类
 * 
 * Copyright (c) 2022 by ccde_terry@163.com, All Rights Reserved. 
 */

/**
 *
 * */
import {get,post} from '../utils/request'

export const getChannelApi = param => get('/api/category/channels',param)
// export const getArticleList = param => get(api.getlist, param)

/**
 * 获取当前登录人频道列表数据=》 不强制用户登录，匿名用户返回后台设置的默认频道列表
 * @returns
 */
 export const getUserChannelApi = param => get('api/cachannels',param)

/**
 * 删除频道
 * @param {*} channelId 频道ID
 */
export const delChannel = param => get(`user/channels/${channelId}` , param)

// /**
//  * 添加频道
//  * @param {*} newChannel:Array 新的频道数据
//  */
// export function addChannelApi (newChannel) {
//   return request.put('user/channels', {
//     channels: newChannel
//   })
// }
